import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "P3K";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const P3KlistCP3K = "Kepegawaian/DokumenPengangkatanP3K/list/";
export const P3KdetailCP3K = "Kepegawaian/DokumenPengangkatanP3K/detailCP3K/";
export const P3KdetailP3K = "Kepegawaian/DokumenPengangkatanP3K/detailP3K/";
export const P3KuploadSKP3K = "Kepegawaian/DokumenPengangkatanP3K/uploadSKP3K/";

export const employeeP3kDownloadSPMT = "Kepegawaian/DokumenPengangkatanP3K/downloadSPMT/";
export const p3kDownloadContract = "Kepegawaian/DokumenPengangkatanP3K/downloadDraftContract/";

export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
